var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarHiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-hi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 5.34619C2 4.24162 2.89543 3.34619 4 3.34619H20C21.1046 3.34619 22 4.24162 22 5.34619V16.829C22 17.9336 21.1046 18.829 20 18.829H15.347C14.8056 18.829 14.2873 19.0485 13.9106 19.4374L13.4364 19.9268C12.6506 20.738 11.3494 20.738 10.5636 19.9268L10.0894 19.4374C9.71266 19.0485 9.19437 18.829 8.65296 18.829H4C2.89543 18.829 2 17.9336 2 16.829V5.34619Z",
    fill: "url(#paint0_linear_103_12720)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 5.34631C2 4.24174 2.89543 3.34631 4 3.34631H20C21.1046 3.34631 22 4.24174 22 5.34631V16.8291C22 17.9337 21.1046 18.8291 20 18.8291H14.5L12 21.4096L9.5 18.8291H4C2.89543 18.8291 2 17.9337 2 16.8291V5.34631Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4998 11.2312H12.501",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5002 11.2312H17.4997",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.50024 11.2312H7.49969",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_12720",
    x1: 2.55556,
    y1: 21.4095,
    x2: 18.0096,
    y2: 4.03167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHiActive);
export default __webpack_public_path__ + "static/media/sidebar-hi-active.fcde2d05676bbd8bf977076a91bc978a.svg";
export { ForwardRef as ReactComponent };